import React from 'react';

const ThankYouPage = ({title ={} , text={}}) => {
  return (
    <div className="thankyou__content">
      <div className="thankyou__wrapper">
        <div className="thankyou__box">
          <h1 className="thankyou__heading">{title || "Thank you!"}</h1>
          <p className="thankyou__text">{text || "Thanks for sharing your thoughts!"}</p>
          <p className="thankyou__text">Your review has been recorded. Stay tuned for more updates and features.</p>
          {/*<button className="thankyou__button">Go Home</button>*/}
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
